import { ConceptLinkerValidatorItemStatus } from 'constants/conceptLinkerValidatorStatus';

export function conceptValidatorItemStatusRenderer(params: { value?: any; data?: any }) {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = parseInt(params.value);

  console.log(`conceptValidatorItemStatusRenderer ${status}`);

  switch (status) {
    case ConceptLinkerValidatorItemStatus.PENDING:
      // Clock icon for pending
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';

    case ConceptLinkerValidatorItemStatus.NEEDS_USER_REVIEW:
      // User icon for needs user review
      return '<span class="fa fa-user" style="color: #2196f3;" title="Needs User Review"></span>';

    case ConceptLinkerValidatorItemStatus.DONE:
      // Check circle icon for done
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Done"></span>';

    default:
      return '';
  }
}
